import { Controller } from "@hotwired/stimulus"
import { pdpCommonProps } from "@/lib/pdpAnalytics"

const OPEN_DELAY = 200
const CLOSE_DELAY = 300

export default class extends Controller {
  static targets = ["trigger", "popover", "sheet"]
  static values = { ratingsCount: Number, average: Number, placement: String }

  disconnect() {
    this.cancelTimers()
    this.unlockBodyScroll()
  }

  open(event) {
    if (this.hoverable) {
      this.openPopover()
    } else {
      event.preventDefault()
      this.openSheet()
    }
  }

  openPopoverOnFocus() {
    if (this.hoverable) this.openPopover()
  }

  scheduleOpen() {
    if (!this.hoverable) return

    clearTimeout(this.closeTimer)
    this.openTimer = setTimeout(() => this.openPopover(), OPEN_DELAY)
  }

  scheduleClose() {
    clearTimeout(this.openTimer)
    this.closeTimer = setTimeout(() => this.close(), CLOSE_DELAY)
  }

  cancelClose() {
    clearTimeout(this.closeTimer)
  }

  openPopover() {
    this.cancelTimers()
    if (!this.popoverTarget.hidden) return

    this.popoverTarget.hidden = false
    this.triggerTarget.setAttribute("aria-expanded", "true")
    this.captureOpened("popover")
  }

  close() {
    this.cancelTimers()
    this.popoverTarget.hidden = true
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  closeOnFocusLeave(event) {
    if (this.element.contains(event.relatedTarget)) return

    this.close()
  }

  openSheet() {
    if (this.sheetTarget.open) return

    this.sheetTarget.showModal()
    this.lockBodyScroll()
    this.triggerTarget.setAttribute("aria-expanded", "true")
    this.captureOpened("sheet")
  }

  closeSheet() {
    this.sheetTarget.close()
    this.sheetClosed()
  }

  sheetClosed() {
    this.unlockBodyScroll()
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  backdropClose(event) {
    if (event.target === this.sheetTarget) this.closeSheet()
  }

  lockBodyScroll() {
    document.body.style.overflow = "hidden"
  }

  unlockBodyScroll() {
    document.body.style.overflow = ""
  }

  captureOpened(surface) {
    const galleryData = document.getElementById("product-gallery")?.dataset || {}

    window.posthog?.capture("pdp_artist_ratings_opened", {
      ...pdpCommonProps(galleryData),
      ratings_count: this.ratingsCountValue,
      average: this.averageValue,
      placement: this.placementValue,
      surface,
    })
  }

  cancelTimers() {
    clearTimeout(this.openTimer)
    clearTimeout(this.closeTimer)
  }

  get hoverable() {
    return window.matchMedia("(hover: hover)").matches
  }
}
